import appReducer from './reducers';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import initialState from '../initialState.json';

// Simple middleware to log dispatches, may be unnecessary if using Redux devtools
const consoleMessages = store => next => action => {
    const suppress_redux_form = true;

    (action.type.indexOf('redux-form') === -1 || !suppress_redux_form) && console.log(`dispatching action => ${action.type}`);
    return next(action);

};

const storeFactory = (initialState = {}) => {
    return applyMiddleware(thunk, consoleMessages)(createStore)(appReducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
}

//Create Redux store
export default storeFactory(initialState);


// WEBPACK FOOTER //
// ./src/store/index.js